import { z } from "zod";
import { isValidPhoneNumber } from 'libphonenumber-js';

export const UserSchema = z.object({
    accountId: z.number().positive().min(1),
    createdBy: z.number().positive().min(1),
    createdOn: z.date(),
    email: z.string().email(),
    enabled: z.boolean(),
    id: z.number().positive().min(1),
    lastLoginOn: z.date(),
    locked: z.boolean(),
    loginAttempts: z.number(),
    isAdministrator: z.boolean(),
    modifiedBy: z.number().positive().min(1),
    modifiedOn: z.date(),
    name: z.string().max(128),
    password: z.string(),
    phoneNumber: z.string().refine((str) => isValidPhoneNumber(str, 'PT')),
    roleId: z.number().positive().min(1).max(3),
    roleType: z.enum(['ADMIN', 'ACCOUNT_MANAGER', 'ACCOUNT_USER']),
});

export type User = z.infer<typeof UserSchema>;